import React, { useState, useContext } from "react";
import { LangCtx, FileCtx,PayLoadCtx} from "../../../../lib/context";
// import "../Styles.css";
// import "./doctorUploadsStyles.css";
import "../../../../ui-styles/animations/ripple.css";
import "../../../../ui-styles/buttons/ButtonFilled.css";
import "../../../../ui-styles/buttons/ButtonTxt.css";
import "../../../../ui-styles/buttons/IconButton.css";
import "../../../../ui-styles/list/ListAutoUnderLine.css";
import "../../../../ui-styles/search/Search.css";
import { formatBytes } from "../../../../lib/functions";
import BtmDeleteSlide from "../../../../lib/ui/BtmDeleteSlider";
// import { Storage } from "aws-amplify";
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
// import config from "../../../../config.json";

const UploadFilesListItem = (props) => {
    const { l } = useContext(LangCtx);
    const { setFileView } = useContext(FileCtx);
    const [slideD, setSlideD] = useState(false);
    const { file } = props;
    const { payload } = useContext(PayLoadCtx);

    const handleSlideD = () => {
        setSlideD(true);
    };
    const handleView = () => {
        setFileView(file);
    };

    // const extension = file.uploadkey.split(".").pop();


    const allowedTypes = ['video/mp4', 'image/png', 'image/jpg', 'image/avif', 'image/jpeg','youtubeUrl']



    const downloadMediaFiles = async () => {
        // Storage.configure({
        //   bucket: process.env.REACT_APP_s3,
        //   region:process.env.REACT_APP_profileRegion,
        // });

        // let result
        //     result = await Storage.get(file.uploadkey.replace('public/', ''), { download: true });

        // }catch(e){
        //     console.log(e)
        // }

        try {
            const response = await fetch(file.url);
            const blob = await response.blob();

            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            const now = new Date();
            const year = now.getFullYear();
            const month = String(now.getMonth() + 1).padStart(2, '0');
            const day = String(now.getDate()).padStart(2, '0');
            const hours = String(now.getHours()).padStart(2, '0');
            const minutes = String(now.getMinutes()).padStart(2, '0');
            const formattedDate = `${year}-${month}-${day}`;
            const formattedTime = `${hours}:${minutes}`; 
            
           
            const filename = `${payload.firstName}${payload.lastName}(${formattedDate})(${formattedTime})`;
            a.href = url;
            a.download = filename;
            a.click();

    
            // Ensure that the URL is revoked after the download
            const clickHandler = () => {
                setTimeout(() => {
                    URL.revokeObjectURL(url);
                    a.removeEventListener('click', clickHandler);
                }, 150);
            };
            a.addEventListener('click', clickHandler, false);
    
            // Trigger the download
            a.click();
        } catch (error) {
            console.error('Error downloading file:', error);
        }

      };
        // try{

    const acceptedTypes = ["jpeg","jpg","png","doc","docx","pdf","xls","xlsx", "ppt", "pptx", "mp4"]

    // console.log('extensions--------', file.uploadkey.split(".").pop());

    // console.log('accepted types', acceptedTypes?.includes(file.uploadkey.split(".").pop()));


    return (
        <div className="listAutoUL" key={file.key}>
            <div className="listAutoAvtr Md listAvatarFile">
                <img
                    src={
                        file.uploadtype === "youtubeUrl"
                            ? `https://img.youtube.com/vi/${file?.uploadkey}/0.jpg` : acceptedTypes?.includes(file.uploadkey.split(".").pop())
                            ? `/images/file-icons/${file?.uploadkey ? file.uploadkey.split(".").pop() : "blank"}-file.png`
                           : `/images/file-icons/blank-file.png`

                    }
                    alt="avatar"
                />
            </div>
            <div className="listAutoContent" onClick={allowedTypes.includes(file.uploadtype) && handleView}>
                <span className="listTxtL linkTxt">{file.uploadname}</span>
                <span className="listTxtM">
                    {l.upload_date} {new Date(file.createdAt).toLocaleString("en-US", { day: "2-digit", month: "short", year: "numeric" })}
                </span>
                <span className="listTxtM">{file.size ? `${l.upload_size + " " + formatBytes(file.size)}` : ""} </span>
                <span className="listTxtM">
                    {l.upload_type} {file.uploadtype === "youtubeUrl" ? "YouTube URL" : file.uploadtype}
                </span>
            </div>
            {!allowedTypes.includes(file.uploadtype) &&
                 <div className="listAutoAction" onClick={downloadMediaFiles} title='Download'>
                 <div className="iconBtnBlock primary Sm ripple">
                     <CloudDownloadIcon/>
                 </div>
             </div>
            }
            {props.access && (
                <div className="listAutoAction" onClick={handleSlideD}>
                    <div className="iconBtnBlock primary Sm ripple">
                        <img src="/images/icons/delete-outline.png" alt="icon" className="invertPrimary"/>
                    </div>
                </div>
            )}
            {slideD && (
                <BtmDeleteSlide
                    slideD={slideD}
                    handleCancel={() => setSlideD(false)}
                    txt={l.conf_del}
                    handleConfirm={() => {props.deleteDocument(file); setSlideD(false)}}
                />
            )}
        </div>
    );
};

export default React.memo(UploadFilesListItem);
